import TruevailRoot from './truevail'

const roots = [
  TruevailRoot
]

export default roots
